var ClubDetailActionType;
(function (ClubDetailActionType) {
    ClubDetailActionType["ClubFetchInit"] = "CLUB_FETCH_INIT";
    ClubDetailActionType["ClubFetchSuccess"] = "CLUB_FETCH_SUCCESS";
    ClubDetailActionType["ClubFetchFailure"] = "CLUB_FETCH_FAILURE";
    ClubDetailActionType["ClubFetchNotFound"] = "CLUB_FETCH_NOTFOUND";
})(ClubDetailActionType || (ClubDetailActionType = {}));
var ClubSearchActionType;
(function (ClubSearchActionType) {
    ClubSearchActionType["ClubSearchFetchInit"] = "CLUB_FETCH_INIT";
    ClubSearchActionType["ClubSearchFetchSuccess"] = "CLUB_FETCH_SUCCESS";
    ClubSearchActionType["ClubSearchFetchFailure"] = "CLUB_FETCH_FAILURE";
    ClubSearchActionType["ClubSearchFetchNotFound"] = "CLUB_FETCH_NOTFOUND";
    ClubSearchActionType["ClubSearchUpdatePyramid"] = "CLUB_UPDATE_PYRAMID";
    ClubSearchActionType["ClubAdd"] = "CLUB_ADD";
})(ClubSearchActionType || (ClubSearchActionType = {}));

export { ClubDetailActionType, ClubSearchActionType };
//# sourceMappingURL=ClubTypes.js.map
